<template>
  <div class="page_chili" id="page_chili" style="height:100%;width:100%">
    <el-row style="text-align: right">
      <el-col>
        <el-radio v-model="radioPage3" label="1" @change="GetData"
          >实时</el-radio>
        <el-radio v-model="radioPage3" label="2" @change="GetData">天</el-radio>
        <el-radio v-model="radioPage3" label="3" @change="GetData">月</el-radio>
        <el-radio v-model="radioPage3" label="4" @change="GetData">年</el-radio>
        <el-date-picker
          v-model="DatePage3"
          type="date"
          placeholder="选择日期"
          @change="GetData"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row style="height:1000px">
      <el-col :span="3" class="span3Css">
        <el-radio-group
          v-model="test"
          @change="GetData()"
          size="mini"
          text-color="red"
          fill="#EEEEEE"
          style="padding: 10, 5, 10, 5; background-color: #9a6ad6"
        >
          <el-radio-button
            style="display: block"
            v-for="(item, i) in items"
            :label="item.content"
            :key="i"
            :disabled="item.disabled"
            :checked="item.checked"
          >
            <div style class="Transbox">
              <img
                src="../../Imag/ja.png"
                style="width: 120px; height: 100px; border: 1px"
              />
              <br />
              <span>{{ item.id }}</span>
            </div>
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col
        :span="15"
        style=" padding: 20px; border: 1px; border-style: inset"
      >
        <span class="h4title">{{ this.titlePage }} 负载率曲线</span>
        <div class="tableTitle block-top-content-2">
          <span class="midText"></span>
        </div>
        <div id="main3" style="width: 900px; height: 600px"></div>
      </el-col>
      <el-col :span="6" style="height: 100%; border: 1px; border-style: inset">
        <el-row>
          <br />
          <span class="h4title">平均负载率</span>
          <br />
          <div class="tableTitle">
            <span class="midText"></span>
          </div>
          <br />
          <div
            id="Page3"
            style="width: 350px; height: 240px; padding: 0; margn: 0"
          ></div>
        </el-row>

        <el-row style="padding: 10px">
          <span>平均负荷率:{{ this.pveLoadStr }}%</span>
          <br />
          <span>变压器容量:{{ this.RatedCapacity }}kVA</span>
          <br />
          <span>运行负载分布图:</span>
        </el-row>
        <el-row>
          <div
            id="Page3_3"
            style="width: 400px; height: 320px; padding: 0px"
          ></div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import request from "../../utils/request";
export default {
  data() {
    return {
      msg: "",
      sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }],
      radioPage3: "1",
      DatePage3: new Date(),
      DataValuePage3: [],
      titlePage: "",
      pveLoadStr: "",
      RatedCapacity: "",
      test: '1',
      items: [
        { id: "一期1#变", content: "1", disabled: false, checked: true },
        { id: "一期2#变", content: "2", disabled: false, checked: false },
        { id: "三期1#变", content: "4", disabled: false, checked: false },
        { id: "二期1#变", content: "5", disabled: false, checked: false },
        { id: "二期2#变", content: "6", disabled: false, checked: false },
        { id: "金桥35kv主变", content: "7", disabled: false, checked: false },
        { id: "金桥10KV备用变", content: "8", disabled: false, checked: false },
      ],
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      console.log("test");
      console.log(this.test);
      this.titlePage = this.text;
      var sizeForm = {
        TimeTypePage3: parseInt(this.radioPage3),
        DateTimePage3: this.DatePage3,
        TransformerID: this.test,
      };
      request({
        url: "MeterTrans/GetPage3Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        var that = this;
        this.drawLine(response);
      });
    },
    drawLine(va) {
      // 基于准备好的dom，初始化echarts实例
      var chart1 = echarts.init(document.getElementById("main3"));
      var data = "";
      var data1 = "";
      var data3 = "";
      var data4 = "";
      if (va.data.code == "1") {
        data = va.data.rust2[0];
        data1 = va.data.rust2[1];
        var anchor = va.data.rust;
        this.pveLoadStr = va.data.Ru3.value;
        var pveLoad = va.data.Ru3;
        var cou = va.data.cou;
        this.RatedCapacity = va.data.RatedCapacity;
      }
      if (va.data.code == "2") {
        data4 = va.data.KArr;
        var anchor = va.data.Date;
        var pveLoad = va.data.Ru3;
        this.pveLoadStr = va.data.Ru3.value;
        this.RatedCapacity = va.data.AlarmLoad;
        var cou = va.data.cou;
        console.log(cou);
      }
      //实时图表
      var option3 = {
        title: {
          text: "",
        },
        color: ["#5B9FE6", "#4034D3"],
        grid: {
          x: 25,
          y: 25,
          x2: 50,
          y2: 20,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
          containLabel: true,
        },
        legend: {
          padding: [50, 0, 20, 0],

          data: ["负载曲线", "告警负荷"],
        },
        textStyle: {
          color: "#fff",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 12,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          formatter: (params) => {
            //格式化数据的函数
            console.log("Page3我的参数", params); //打印出来的数据（营业，网络，房屋，tgtn,g）
            return (
              "负载率<br/>" +
              params[0].name +
              "<br/>实际负荷率:" +
              params[0].value[1] +
              "<br/>负荷率限值:" +
              params[1].value[1]
            );
          },
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            }, //区域缩放，区域缩放还原
            dataView: {
              readOnly: false,
            }, //数据视图
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
            restore: {}, //还原
            saveAsImage: {}, //保存为图片
          },
        },
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "负载曲线",
            type: "line",
            showSymbol: false,
            hoverAnimation: false,
            data: data,
            symbol: "none", //不显示圆点
          },
          {
            name: "告警负荷",
            type: "line",
            symbol: "none", //不显示圆点
            data: data1,
          },
        ],
      };
      //day month
      var Page3_Day_Option = {
        color: ["#2878cc", "#2f4554", "#61a0a8"],
        title: {
          text: "",
          subtext: "",
          sublink: "",
        },
        legend: {
          textStyle: {
            color: "rgba(91, 127, 234, 1)",
          },
          data: ["负荷率"],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            //格式化数据的函数
            console.log("我的参数", params); //打印出来的数据（营业，网络，房屋，tgtn,g）
            return (
              "负载率<br/>" +
              params[0].name +
              "<br/>最小值:" +
              params[0].data[1] +
              "<br/>最大值:" +
              params[0].data[2]
            );
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          splitLine: { show: false },
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          data: anchor,
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            text: "三相电流不平衡率",
            type: "k",
            data: data4,
            itemStyle: {
              //图形样式
              normal: { color: "#61a0a8" },
              lineStyle: {
                width: 2,
                color: "#61a0a8", // 阳线边框颜色
                color0: "green", // 阴线边框颜色
              },
            },
          },
        ],
      };

      if (va.data.code == "1") {
        chart1.setOption(option3);
      } else {
        chart1.clear();
        chart1.setOption(Page3_Day_Option);
      }
      console.log("echarts111");
      var chart32 = echarts.init(document.getElementById("Page3"));
      var optionPage3 = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        grid: {
          top: "0",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "负载率",
            type: "gauge",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0,
            detail: { formatter: "{value}%" },
            data: [pveLoad],
          },
        ],
      };
      chart32.setOption(optionPage3, true);

      var chartPagr3_3 = echarts.init(document.getElementById("Page3_3"));
      var Page3_3_option = {
        color: ["#blue"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: (params) => {
              //格式化数据的函数
              console.log("我的参数", params); //打印出来的数据（营业，网络，房屋，tgtn,g）
              return (
                "负载率<br/>" +
                params[0].name +
                "<br/>最小值:" +
                params[0].data[1] +
                "<br/>最大值:" +
                params[0].data[2]
              );
            },
          },
          grid: {
            top: "0",
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          data: [
            "0%",
            "10%",
            "20%",
            "30%",
            "40%",
            "50%",
            "60%",
            "70%",
            "80%",
            "90%",
            "100%",
          ],
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: cou,
            type: "line",
            areaStyle: {},
          },
        ],
      };
      chartPagr3_3.setOption(Page3_3_option, true);
    },
  },
};
</script>
<style>
@import "./page.css";
</style>
